import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-white text-base"></i>
              </span>
              <span className="text-lg font-bold text-white font-heading">91黑料网</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">{footerData.description}</p>
          </div>

          {footerData.sections.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-bold text-white mb-4">{section.title}</h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8">
          <h4 className="text-sm font-bold text-white mb-4">{footerData.partners.title}</h4>
          <div className="flex flex-wrap gap-4">
            <span className="px-4 py-2 bg-foreground-900 rounded-lg text-xs text-foreground-500">虚位以待</span>
            <span className="px-4 py-2 bg-foreground-900 rounded-lg text-xs text-foreground-500">虚位以待</span>
            <span className="px-4 py-2 bg-foreground-900 rounded-lg text-xs text-foreground-500">虚位以待</span>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">© 2025 91黑料网 版权所有 | 本站内容仅供娱乐参考，不构成任何建议</p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => { e.preventDefault(); handleClick('#hero'); }} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">回到顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}